import React from "react";
import { projects } from "../data/mock";

const Projects = () => {
  return (
    <section id="projects" className="section bg-[#0B1E3F] text-[#F8F5EE] relative overflow-hidden">
      <div className="absolute inset-0 grain" />
      <div className="max-w-7xl mx-auto container-px relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-8 reveal">
            <span className="eyebrow">
              <span className="text-[#F8F5EE]/80">Selected Projects & Studies</span>
            </span>
            <h2 className="h-section text-3xl lg:text-5xl mt-6 text-[#F8F5EE]">
              Research, audits and
              <br />
              <span className="italic text-[#C9A961]">programme outcomes.</span>
            </h2>
          </div>
          <p className="lg:col-span-4 text-[15px] text-[#F8F5EE]/70 leading-relaxed reveal">
            A glimpse into the studies and large-scale programmes that have shaped DianaMik's quality methodology.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#F8F5EE]/15 border border-[#F8F5EE]/15">
          {projects.map((p, i) => (
            <article
              key={i}
              className="bg-[#0B1E3F] p-8 lg:p-10 reveal group hover:bg-[#0B1E3F]/70 transition-colors duration-500"
            >
              <div className="flex items-center justify-between">
                <span className="text-[11px] tracking-[0.25em] uppercase text-[#C9A961]">
                  {p.type}
                </span>
                <span className="font-serif text-[#F8F5EE]/30 text-2xl">0{i + 1}</span>
              </div>
              <h3 className="font-serif text-2xl lg:text-3xl text-[#F8F5EE] mt-6 leading-snug">
                {p.title}
              </h3>
              <p className="mt-4 text-[14.5px] text-[#F8F5EE]/65 leading-relaxed">
                {p.summary}
              </p>
              <div className="mt-8 h-px w-12 bg-[#C9A961] group-hover:w-24 transition-all duration-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
